import React, { useState } from 'react';
import DENTModalOverviewGeneralEndodonticButtons from './DENTModalOverviewGeneralEndodonticButtons';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import { ToothEndodontic } from '../../../../graphql/graphql';
import DENTModalOverviewGeneralEndodonticElectricityButtons from './DENTModalOverviewGeneralEndodonticElectricityButtons';

interface Props {
	onClose: () => void;
}

const electricityValues = Array.from({ length: 10 }, (_, i) => i + 1);

const DENTModalOverviewGeneralEndodonticElectricity = ({ onClose }: Props) => {
	const [value, setValue] = useState<ToothEndodontic['electric']>();

	return (
		<DENTModalOverviewGeneralEndodonticButtons
			type={'electric'}
			values={value}
			onClose={onClose}>
			<DENTModalOverviewGeneralEndodonticElectricityButtons
				value={value}
				onChange={setValue}
			/>
		</DENTModalOverviewGeneralEndodonticButtons>
	);
};

export default DENTModalOverviewGeneralEndodonticElectricity;
